export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_RESET = 'AUTH_RESET';

export const SET_AUTH_USER_EMAIL = 'SET_AUTH_USER_EMAIL';
export const SET_AUTH_USER_PASSWORD = 'SET_AUTH_USER_PASSWORD';
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';

export const SET_SESSION_REVOKE_REQUESTED = 'SET_SESSION_REVOKE_REQUESTED';

export const TWO_FACTOR_AUTH_START = 'TWO_FACTOR_AUTH_START';
export const TWO_FACTOR_AUTH_RESET = 'TWO_FACTOR_AUTH_RESET';
export const SET_NEW_PASSWORD_REQUIREMENTS = 'SET_NEW_PASSWORD_REQUIREMENTS';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';
export const SET_USER_COUNTRY = 'SET_USER_COUNTRY';
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO';
export const SET_ACCOUNT_SMS_BILLING_VIEWED = 'SET_ACCOUNT_SMS_BILLING_VIEWED';
export const SET_USER_EXTENSION = 'SET_USER_EXTENSION';

export const PHONE_SET_NEW_UA = 'PHONE_SET_NEW_UA';
// export const PHONE_REGISTER = 'PHONE_REGISTER';
export const PHONE_REGISTER_ERROR = 'PHONE_REGISTER_ERROR';
export const PHONE_UNREGISTERED = 'PHONE_UNREGISTERED';
export const PHONE_DEVICE_SETUP = 'PHONE_DEVICE_SETUP';
export const PHONE_DEVICE_CHANGE = 'PHONE_DEVICE_CHANGE';
export const RESET_PHONES = 'RESET_PHONES';
// export const NEW_SESSION = 'NEW_SESSION';

export const CALL_IN_PROGRESS = 'CALL_IN_PROGRESS';
export const CALL_STATUS = 'CALL_STATUS';
export const CALL_INCOMING = 'CALL_INCOMING';
export const CALL_OUTGOING = 'CALL_OUTGOING';
export const CALL_ACCEPTED = 'CALL_ACCEPTED';
export const CALL_BUSY = 'CALL_BUSY';
export const CALL_FAILED = 'CALL_FAILED';
export const CALL_NOANSWER = 'CALL_NOANSWER';
export const CALL_REJECTED = 'CALL_REJECTED';
export const CALL_CANCELED = 'CALL_CANCELED';
export const CALL_FINISHED = 'CALL_FINISHED';
export const CALL_HOLD = 'CALL_HOLD';
export const CALL_TRANSFERED = 'CALL_TRANSFERED';
export const CALL_CONFERENCE = 'CALL_CONFERENCE';

export const CALL_LOGS_STORE = 'CALL_LOGS_STORE';
export const CALL_LOGS_SUCCESS = 'CALL_LOGS_SUCCESS';
export const CALL_LOGS_FAILURE = 'CALL_LOGS_FAILURE';
export const CALL_LOGS_RESET = 'CALL_LOGS_RESET';
export const RESET_CALL_LOGS_PAGES = 'RESET_CALL_LOGS_PAGES';
export const CALL_LOGS_OPEN_ENHANCED_SEARCH = 'CALL_LOGS_OPEN_ENHANCED_SEARCH';
export const CALL_LOGS_IN_FOCUS = 'CALL_LOGS_IN_FOCUS';
export const CALL_LOGS_CALL_DETAILS = 'CALL_LOGS_CALL_DETAILS';
export const GET_EXTENSIONS = 'GET_EXTENSIONS';
export const UPDATE_EXTENSIONS = 'UPDATE_EXTENSIONS';
export const CHECK_UPDATE = 'CHECK_UPDATE';
export const USER_INTERACTION_UPDATE_DIALOG = 'USER_INTERACTION_UPDATE_DIALOG';

export const CONTACTS_STORE = 'CONTACTS_STORE';
export const CONTACTS_SUCCESS = 'CONTACTS_SUCCESS';
export const CONTACTS_FAILURE = 'CONTACTS_FAILURE';
export const CONTACTS_RESET = 'CONTACTS_RESET';
export const CONTACTS_UPDATE = 'CONTACTS_UPDATE';
export const CONTACT_SET_ORG_GROUPS = 'CONTACT_SET_ORG_GROUPS';

export const CHANGE_STATUS = 'CHANGE_STATUS';
export const SAVE_FAVORITE_AGENTS = 'SAVE_FAVORITE_AGENTS';
export const SAVE_SOCKET_IO = 'SAVE_SOCKET_IO';
export const VOICE_MESSAGE_RECEIVED = 'VOICE_MESSAGE_RECEIVED';
export const RESET_STATUS = 'RESET_STATUS';

export const UPDATE_CREDENTIALS = 'UPDATE_CREDENTIALS';
export const SYSTEM_SAVE = 'SYSTEM_SAVE';
export const DEV_MODE = 'DEV_MODE';
export const CONSOLE = 'CONSOLE';
export const CHECKED_HISTORY = 'CHECKED_HISTORY';
export const CHECKED_CONTACTS = 'CHECKED_CONTACTS';
export const STATUS_SYSTEM = 'STATUS_SYSTEM';
export const TRANSFER_PREFERENCE = 'TRANSFER_PREFERENCE';
export const RING_DEVICE = 'RING_DEVICE';
export const CHANGE_RINGTONE = 'CHANGE_RINGTONE';
export const SAVE_SOUNDS = 'SAVE_SOUNDS';
export const STATUS_SOUNDS = 'STATUS_SOUNDS';
export const SET_REMOTE_VIDEO = 'SET_REMOTE_VIDEO';
export const SET_LOCAL_VIDEO = 'SET_LOCAL_VIDEO';
export const UPDATE_SOUNDS_DEVICE = 'UPDATE_SOUNDS_DEVICE';
export const RESET_SYSTEM = 'RESET_SYSTEM';
export const SET_VOLUME = 'SET_VOLUME';
export const SET_VERSION = 'SET_VERSION';
export const NUMBER_TO_TRANSFER = 'NUMBER_TO_TRANSFER';
export const NUMBER_CONTACT_TO_TRANSFER = 'NUMBER_CONTACT_TO_TRANSFER';
export const CALLER_ID_COUNTRY_CODE = 'CALLER_ID_COUNTRY_CODE';
export const TEMPORARY_COUNTRY_CODE = 'TEMPORARY_COUNTRY_CODE';
export const TEMPORARY_ISO_CODE = 'TEMPORARY_ISO_CODE';
export const START_ON_BOOT = 'START_ON_BOOT';
export const NEW_VERSION_AVAILABLE = 'NEW_VERSION_AVAILABLE';
export const UPDATER_DATE_TIME = 'UPDATER_DATE_TIME';
export const UPDATER_MESSAGE = 'UPDATER_MESSAGE';
export const SET_LAST_DIALED_NUMBER = 'SET_LAST_DIALED_NUMBER';
export const SET_CALL_WAITING_SOUND = 'SET_CALL_WAITING_SOUND';
export const SET_SYSTEM_IS_BUSY = 'SET_SYSTEM_IS_BUSY';
export const DISABLE_KEYPAD_TONE = 'DISABLE_KEYPAD_TONE';
export const SET_ANNOUNCEMENTS = 'SET_ANNOUNCEMENTS';

export const UPDATE_CALLS_CURRENT_LOADING = 'UPDATE_CALLS_CURRENT_LOADING';
export const UPDATE_CALLS_CURRENT_FINISH = 'UPDATE_CALLS_CURRENT_FINISH';
export const UPDATE_CALLS_CURRENT_ACTIVE = 'UPDATE_CALLS_CURRENT_ACTIVE';
export const RESET_CALLS_CURRENT = 'RESET_CALLS_CURRENT';

export const ISSUE_REPORT = 'ISSUE_REPORT';
export const ISSUE_REPORT_RESET = 'ISSUE_REPORT_RESET';

export const ADD_DRAFT = 'ADD_DRAFT';
export const REMOVE_DRAFT = 'REMOVE_DRAFT';
export const RESET_DRAFT = 'RESET_DRAFT';

export const NOTES_RESET = 'NOTES_RESET';
export const NOTES_STORE = 'NOTES_STORE';

export const TAGS_STORE = 'TAGS_STORE';
export const TAGS_STORE_SUCCESS = 'TAGS_STORE_SUCCESS';

export const HUBSPOT_INCOMMING_CALLS = 'HUBSPOT_INCOMMING_CALLS';
export const SET_NUACOM_INTEGRATIONS = 'SET_NUACOM_INTEGRATIONS';

export const FETCH_ENABLED_INTEGRATIONS_SUCCESS =
  'FETCH_ENABLED_INTEGRATIONS_SUCCESS';
export const FETCH_ENABLED_INTEGRATIONS = 'FETCH_ENABLED_INTEGRATIONS';
export const FETCH_CONTACTS_INTEGRATIONS_SUCCESS =
  'FETCH_CONTACTS_INTEGRATIONS_SUCCESS';
export const STORE_CONTACTS_INTEGRATIONS = 'STORE_CONTACTS_INTEGRATIONS';
export const CLEAR_CONTACTS_INTEGRATIONS = 'CLEAR_CONTACTS_INTEGRATIONS';
export const FETCH_INTEGRATION_CONTACT_ONWER_SUCCESS =
  'FETCH_INTEGRATION_CONTACT_ONWER_SUCCESS';
export const RESET_INTEGRATIONS_CONTACTS = 'RESET_INTEGRATIONS_CONTACTS';

export const STATUS = {
  BUSY: 'Busy',
  AVAILABLE: 'Available',
  UNAVAILABLE: 'Unavailable',
};
export const STORE_TICKETS_INTEGRATIONS = 'STORE_TICKETS_INTEGRATIONS';

export const STORE_AFTER_CALL_RULES = 'STORE_AFTER_CALL_RULES';
/**
 * Emitted when storing infos about a call that contains mandatory tagging
 */
export const STORE_MANDATORY_CALL_TAGGNING_INFO =
  'STORE_MANDATORY_CALL_TAGGNING_INFO';
/**
 * Emitted when a call tagging rules is fulfilled or the countdown timer is expired
 */
export const EXPIRED_OR_SUCCESS_MANDATORY_CALL_TAGGNING =
  'EXPIRED_OR_SUCCESS_MANDATORY_CALL_TAGGNING';
export const MANDATORY_BUSY_STATE_CHANGE = 'MANDATORY_BUSY_STATE_CHANGE';

export const SET_HISTORY_FILTER_OPTIONS = 'SET_HISTORY_FILTER_OPTIONS';
export const SET_CURRENT_HISTORY_TAB = 'SET_CURRENT_HISTORY_TAB';
export const SET_CALL_LOGS_PAGE_OFFSET = 'SET_CALL_LOGS_PAGE_OFFSET';
export const UPDATE_CONTACTS_CALL_SYNC_WITH_CRM =
  'UPDATE_CONTACTS_CALL_SYNC_WITH_CRM';
export const CLEAR_HISTORY_CUSTOM_FILTERS = 'CLEAR_HISTORY_CUSTOM_FILTERS';

export const DYNAMIC_QUEUES_STORE = 'DYNAMIC_QUEUES_STORE';
export const RESET_DYNAMIC_QUEUES = 'RESET_DYNAMIC_QUEUES';
export const UPDATE_INTEGRATIONS_ORDER_PREFERENCE =
  'UPDATE_INTEGRATIONS_ORDER_PREFERENCE';
export const RESET_CALL_ITEMS = 'RESET_CALL_ITEMS';
export const RESET_HISTORY_FILTER_OPTIONS = 'RESET_HISTORY_FILTER_OPTIONS';
export const SET_SALESFORCE_DISPLAY_SPECIFIC_EXTERNAL_ID =
  'SET_SALESFORCE_DISPLAY_SPECIFIC_EXTERNAL_ID';
export const CALL_NO_MORE_ITEMS = 'CALL_NO_MORE_ITEMS';

export const VIDEO_NEW_CALL = 'VIDEO_NEW_CALL';
export const UPDATE_VIDEO_CALL = 'UPDATE_VIDEO_CALL';
export const VIDEO_CALL_ACTIVE = 'VIDEO_CALL_ACTIVE';
export const CALL_LOGS_UPDATE_RECORDING_STATUS =
  'CALL_LOGS_UPDATE_RECORDING_STATUS';

export const CONVERSATION_SET_CONVERSATIONS_LIST =
  'CONVERSATION_SET_CONVERSATIONS_LIST';
export const CONVERSATION_SET_ACTIVE_CHAT = 'CONVERSATION_SET_ACTIVE_CHAT';
export const CONVERSATION_SET_SEARCH_FOR = 'CONVERSATION_SET_SEARCH_FOR';
export const CONVERSATION_RESET = 'CONVERSATION_RESET';
export const CONVERSATION_RESET_CONVERSATIONS_LIST =
  'CONVERSATION_RESET_CONVERSATIONS_LIST';
export const CONVERSARTION_OPEN_SELECTION = 'CONVERSARTION_OPEN_SELECTION';
export const CONVERSARTION_ISLOADING = 'CONVERSARTION_ISLOADING';
export const CONVERSARTION_HIDDEN_BOTTOMNAV = 'CONVERSARTION_HIDDEN_BOTTOMNAV';
export const ACCOUNT_INFO_SET_SMS_TEMPLATE = 'ACCOUNT_INFO_SET_SMS_TEMPLATE';
export const ACCOUNT_INFO_SET_SMS_SENDERS = 'ACCOUNT_INFO_SET_SMS_SENDERS';
export const CONVERSARTION_SET_FILTERS = 'CONVERSARTION_SET_FILTERS';
export const CONVERSARTION_SET_BADGE_COUNTER =
  'CONVERSARTION_SET_BADGE_COUNTER';
export const CONVERSARTION_SET_PAGE = 'CONVERSARTION_SET_PAGE';
export const CONVERSARTION_SET_TOTAL_SIZE = 'CONVERSARTION_SET_TOTAL_SIZE';
export const CONVERSATION_SET_LAST_READ_INDEX =
  'CONVERSATION_SET_LAST_READ_INDEX';
export const ACCOUNT_INFO_SET_USER_LIST = 'ACCOUNT_INFO_SET_USER_LIST';
export const ACCOUNT_INFO_SET_DEPARTMENTS = 'ACCOUNT_INFO_SET_DEPARTMENTS';
export const ACCOUNT_INFO_SET_TOUR_COMPLETED =
  'ACCOUNT_INFO_SET_TOUR_COMPLETED';
